import { KkmRegisterMethod } from './kkm-register-methods.types';

export const KKM_REGISTER_METHODS: KkmRegisterMethod[] = [
  {
    title: 'new.kkm.title',
    link: '/main/kkms/register-kkm',
    icon: 'plus',
    name: 'add',
  },
  {
    title: 'new.kkm.transition.ofd.title',
    link: '/main/kkms/register-kkm',
    icon: 'transfer',
    name: 'transfer',
  },
];
